export default {"src":"/_next/static/media/Climate-Change-animation.82c7eca7.gif","height":1084,"width":1930};